import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../store';
import ToggleButtonListItem from '../../../../../list-items/ToggleButtonListItem';
import { LAYOUT_TYPE } from '../../../Preview/PreviewDisplayConstants';

const layoutTypeOptions = [
    {value: LAYOUT_TYPE.WEBBED, text: 'Web'},
    {value: LAYOUT_TYPE.STACKED, text: 'Stack'},
    {value: LAYOUT_TYPE.LAYERED, text: 'Combo'},
    {value: LAYOUT_TYPE.TARGET, text: 'Scale'}
];

const VisualizerLayoutTypeListItem = (props) => {
    const { visualizerLayoutType, updateVisualizerLayersType } = props;
    const onTypeChange = (value) => updateVisualizerLayersType(value);
    
    return (
        <ToggleButtonListItem
            text='Layers'
            value={visualizerLayoutType}
            onChange={onTypeChange}
            options={layoutTypeOptions}
            toolTip={
                <>
                    <p>How multiple wave layers will be arranged.</p>
                    <p>WEB: Waves have equal height, but further back waves are wider.</p>
                    <p>STACK: Waves have equal width, but further back waves are higher.</p>
                    <p>COMBO: Further back waves are higher and wider.</p>
                    <p>SCALE: Further back layers are scaled up copies of the front layer.</p>
                </>
            }
        />
    );
};

const mapStateToProps = (state) => {
    const { layoutType: visualizerLayoutType } = state.createPreview.present.videoSettings.visualizer;
    return { visualizerLayoutType };
}

const mapDispatchToProps = (dispatch) => {
    const updateVisualizerLayersType = (layoutType) => dispatch(createActions.updateVisualizerLayersType(layoutType));
    return { updateVisualizerLayersType }
}

export default connect(mapStateToProps, mapDispatchToProps)(VisualizerLayoutTypeListItem);